import {createFileRoute, redirect} from '@tanstack/react-router';
import EventList from '@/patient/views/event/EventsList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(patient)/events')({
  component: EventList,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
